import React, { FC } from "react";

import CardGuideStep from "../CardGuideStep/CardGuideStep";

import { Button, Grid, Typography } from "@components/base";

interface CardGuideStepDetail {
  detail: CardGuideStep["detail"];
  button: CardGuideStep["button"];
}

const CardGuideStepDetail: FC<CardGuideStepDetail> = ({ detail, button }) => (
  <Grid container justifyContent="space-between" spacing={3}>
    <Grid>
      <Typography>{detail?.title}</Typography>
      <ul>
        {detail?.points.map((point, index) => (
          <li key={`detail-point-${index}`}>{point}</li>
        ))}
      </ul>
    </Grid>
    <Grid>
      {button && (
        <Button
          variant="outlined"
          size="small"
          onClick={button?.onClick}
          href={button?.href}
        >
          {button?.text}
        </Button>
      )}
    </Grid>
  </Grid>
);

export default CardGuideStepDetail;
